import { countryCodeMap } from '../components/form-fields/CountrySelect';

const countryOverrides = {
  GB: 'UK'
};

const getLocationString = (vals, defaultValue = 'no location info...') => {
  const { city, region, country } = vals || {};
  const locations = [];

  city && locations.push(city);
  region && locations.push(region);
  country && locations.push(countryOverrides[country] || country);

  if (locations.length === 1 && country) {
    return countryCodeMap[country]?.countryName || country;
  }

  return locations.join(', ') || defaultValue;
}

const _slugify = value => (value || '').toLowerCase().replace(/[^\w\s-]/g, '').replace(/[-\s]+/g, '-').replace(/[-_]*$/, '');

const slugifyProject = ({ id, title }) => `${id}/${_slugify(title)}`;

export {
  getLocationString,
  slugifyProject
};
